import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.array.map";
import React from 'react';
export default (function (_ref) {
  var lines = _ref.lines;
  return (
    /*#__PURE__*/
    React.createElement("ul", {
      className: "math"
    }, lines.map(function (line) {
      var m = line.match(/\\item (.*)/);

      if (m) {
        return (
          /*#__PURE__*/
          React.createElement("li", null, m[1])
        );
      } else {
        return line;
      }
    }))
  );
});